import { render } from "./taskSearch.vue?vue&type=template&id=7a641d0e&scoped=true"
import script from "./taskSearch.vue?vue&type=script&lang=js"
export * from "./taskSearch.vue?vue&type=script&lang=js"

import "./taskSearch.vue?vue&type=style&index=0&id=7a641d0e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a641d0e"]])

export default __exports__